"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _checkoutRegistration = require("@ori/checkout-registration");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _styles = require("./styles");
var _useRegistrationWrapper = require("./useRegistrationWrapper");
var _jsxRuntime = require("react/jsx-runtime");
const RegistrationWrapper = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { handleCallbackRegistrationId, isConsultantNumberLoading, onRegistrationClose, registrationConfiguration } = (0, _useRegistrationWrapper.useRegistrationWrapper)();
    if (isConsultantNumberLoading) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        ...getTestIdProps(_models.TestId.CheckoutRegistrationWrapper),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Close, {
                onClick: onRegistrationClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutRegistration.CheckoutRegistration, {
                configuration: registrationConfiguration,
                handleCallbackRegistrationId: handleCallbackRegistrationId
            })
        ]
    });
};
var _default = exports.default = RegistrationWrapper;
